<template lang="pug">
  td
    .loading(v-if="dissection.loading") Loading...
    .info(v-else)
      .status {{ status }}
      .messages.pt5(v-if="resultMessages")
        div(v-for="m in resultMessages")
          span -
          b.ml5 {{m.code}}:
          span.ml5 {{ m.message }}
</template>
<script>
export default {
  props: ['dissection'],
  computed: {
    status() {
      if (this.dissection.error) {
        return this.dissection.error
      }
      const bv = this.dissection.batchValidationResult
      if (!bv) {
        return ''
      }
      const { status } = bv.result
      return status
    },
    resultMessages() {
      const bv = this.dissection.batchValidationResult
      if (!bv) {
        return null
      }
      return bv.result.errors
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/dissector/components/InfoCell.vue